import React from 'react';
import { Icon } from 'hfs-common-ui';
import useTopBannerRegistration from '~/hooks/use-top-banner-registration';
import * as S from './styled';

const APP_ICON_SRC = '/images/app-icon-hfs.svg';
const BANNER_HEIGHT = 80;

export interface Props {
  storeLabel: string;
  ctaLabel: string;
  ctaUrl: string;
  title: string;
  publisher: string;
  dismissAriaLabel: string;
  appIconAlt: string;
  onDismiss: () => void;
  testId: string;
}

const AppInstallBanner = ({
  storeLabel,
  ctaLabel,
  ctaUrl,
  title,
  publisher,
  dismissAriaLabel,
  appIconAlt,
  onDismiss,
  testId,
}: Props) => {
  useTopBannerRegistration(BANNER_HEIGHT);

  return (
    <S.BannerDiv data-testid={testId}>
      <S.CloseButton type="button" aria-label={dismissAriaLabel} onClick={onDismiss}>
        <Icon type="action.close" size="small" color="onSurface" />
      </S.CloseButton>
      <S.IconImg src={APP_ICON_SRC} alt={appIconAlt} />
      <S.TextDiv>
        <S.TitleSpan>{title}</S.TitleSpan>
        <S.SubtitleSpan>{publisher}</S.SubtitleSpan>
        <S.StoreSpan>{storeLabel}</S.StoreSpan>
      </S.TextDiv>
      <S.ViewLink href={ctaUrl}>{ctaLabel}</S.ViewLink>
    </S.BannerDiv>
  );
};

export default AppInstallBanner;
